<template>
    <div id="v-product-wrap">
        <!-- 顶部栏 -->
        <div class="head">
            <dl>
                <dt>
                    <img class="logo" :src="$config.resource + 'dhl_logo.png'" alt="">
                </dt>
                <!-- 头像信息 -->
                <dd>
                    <div class="portrait">
                        <img class="pic" :src="user.head" alt="">
                    </div>
                    <p>{{user.company_name}}</p>
                    <div class="quit" @click="onQuit">
                        <img class="icon" :src="$config.resource + 'tc.png'" alt="">
                    </div>
                </dd>
            </dl>
        </div>
        <!-- 主要部分 -->
        <div class="main_box">
            <!-- 步骤 -->
            <div class="step">
                <img class="pic_bg" :src="$config.resource + 'db_bjt.png'" alt="">
                <div class="row_box">
                    <div class="row curr">
                        <div class="circle">1</div>
                        <p>选择供应商类型</p>
                    </div>
                    <div class="wire white"></div>
                    <div class="row curr">
                        <div class="circle">2</div>
                        <p>企业概况</p>
                    </div>
                    <div class="wire white"></div>
                    <div class="row curr">
                        <div class="circle">3</div>
                        <p>工厂概况</p>
                    </div>
                    <div class="wire white"></div>
                    <div class="row curr">
                        <div class="circle">4</div>
                        <p>产品概况</p>
                    </div>
                    <div class="wire"></div>
                    <div class="row">
                        <div class="circle">5</div>
                        <p>提交</p>
                    </div>
                </div>
            </div>
            <!-- 产品品类（按品类填，品类多按以下内容提供-供货清单） -->
            <div class="alike alike_one">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>产品品类（按品类填，品类多按以下内容提供-供货清单）</p>
                    <div class="remark">备注：提供纯服务供应商无须填写（其他供应商需必填）</div>
                </div>
                <ul>
                    <li>
                        <div class="name">
                            <div class="tt design">主要生产产品种类：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="kind_one" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">上年年产量：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="last_year_one" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">实际年产量：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="practical_one" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">总体销售额：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="total_one" />
                            <div class="unit">万元</div>
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">配套额：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="mating_one" />
                            <div class="unit">万元</div>
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">综合质量能力PPM：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="quality_one" />
                        </div>
                    </li>
                </ul>
                <ul v-if="variety">
                    <li>
                        <div class="name">
                            <div class="tt design">主要生产产品种类：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="kind_two" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">上年年产量：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="last_year_two" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">实际年产量：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="practical_two" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">总体销售额：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="total_two" />
                            <div class="unit">万元</div>
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">配套额：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="mating_two" />
                            <div class="unit">万元</div>
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">综合质量能力PPM：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="quality_two" />
                        </div>
                    </li>
                </ul>
                <div class="add" v-if="!variety&&isType!=2" @click="onVariety">新增产品品类</div>
            </div>
            <!-- 体系认证情况/行业资质情况 -->
            <div class="alike">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>体系认证情况/行业资质情况</p>
                </div>
                <ul>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">何种体系认证/何种资质证书：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="approve_one" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">认证时间：</div>
                        </div>
                        <el-date-picker
                            v-model="ms_one"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择">
                        </el-date-picker>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">有效期：</div>
                        </div>
                        <el-date-picker
                            v-model="validity_one"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择">
                        </el-date-picker>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">认证机构：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="institution_one" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">证书编号：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="number_one" />
                        </div>
                    </li>
                </ul>
                <ul v-if="isRapex">
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">何种体系认证/何种资质证书：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="approve_two" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">认证时间：</div>
                        </div>
                        <el-date-picker
                            v-model="ms_two"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择">
                        </el-date-picker>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">有效期：</div>
                        </div>
                        <el-date-picker
                            v-model="validity_two"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择">
                        </el-date-picker>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">认证机构：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="institution_two" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">证书编号：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="number_two" />
                        </div>
                    </li>
                </ul>
                <div class="add" v-if="!isRapex&&isType!=2" @click="onRapex">新增体系认证情况</div>
            </div>
            <!-- 代理（品类多按以下内容提供-供货清单） -->
            <div class="alike">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>代理（品类多按以下内容提供-供货清单）</p>
                    <div class="remark">备注：提供纯服务供应商无须填写（其他供应商需必填）</div>
                </div>
                <ul>
                    <li>
                        <div class="name">
                            <div class="tt design">主代理品牌：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="lord" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">代理等级：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="grade_one" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">代理年限（需附代理证书）：</div>
                        </div>
                        <div class="inp_unit">
                            <input 
                                class="uploadBtn" 
                                name="key" 
                                type="file" 
                                @change="uploadFile($event)" 
                                ref="inputer_one" 
                                accept=".pdf" 
                            />
                            <p v-if="agency_one!=''">已上传</p>
                            <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">其他代理品牌：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="rest" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">代理等级：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="grade_two" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">代理年限（需附代理证书）：</div>
                        </div>
                        <div class="inp_unit">
                            <input 
                                class="uploadBtn" 
                                name="key" 
                                type="file" 
                                @change="restsFile($event)" 
                                ref="inputer" 
                                accept=".pdf" 
                            />
                            <p v-if="agency_two!=''">已上传</p>
                            <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">代理区域：</div>
                        </div>
                        <el-select class="elect" v-model="area_name" @change="getArea">
                            <el-option
                            v-for="item in area"
                            :key="item.name"
                            :label="item.name"
                            :value="item">
                            </el-option>
                        </el-select>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">代理区域市场份额：</div>
                        </div>
                        <el-select class="elect" v-model="quotient_name" @change="getQuotient">
                            <el-option
                            v-for="item in quotient"
                            :key="item.name"
                            :label="item.name"
                            :value="item">
                            </el-option>
                        </el-select>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">主要来货渠道：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="channel" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">曾代理的主要产品：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="staple" />
                        </div>
                    </li>
                </ul>
            </div>
            <!-- 其他 -->
            <div class="alike">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>其他</p>
                </div>
                <ul>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">交期：</div>
                        </div>
                        <el-select class="elect" v-model="deal_name" @change="getDeal">
                            <el-option
                            v-for="item in deal"
                            :key="item.name"
                            :label="item.name"
                            :value="item">
                            </el-option>
                        </el-select>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">物流配送：</div>
                        </div>
                        <el-select class="elect" v-model="logistics" @change="getDelivery">
                            <el-option
                            v-for="item in delivery"
                            :key="item.name"
                            :label="item.name"
                            :value="item">
                            </el-option>
                        </el-select>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">有无实验室：</div>
                        </div>
                        <el-select class="elect" v-model="lab_name" @change="getLaboratory">
                            <el-option
                            v-for="item in laboratory"
                            :key="item.name"
                            :label="item.name"
                            :value="item">
                            </el-option>
                        </el-select>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">有无生产设备：</div>
                        </div>
                        <el-select class="elect" v-model="facility" @change="getFacility">
                            <el-option
                            v-for="item in equipment"
                            :key="item.name"
                            :label="item.name"
                            :value="item">
                            </el-option>
                        </el-select>
                    </li>
                </ul>
            </div>
            <!-- 按钮 -->
            <div class="btn_box">
                <div class="btn gray" v-if="isType!=2" @click="onSave">保存草稿</div>
                <div class="btn gray" @click="onBack">上一步</div>
                <div class="btn red" v-if="isType!=2" @click="onSubmit">下一步</div>
                <div class="btn red" v-if="isType==2" @click="toViewPage('/submit',{type:2})">下一步</div>
            </div>
        </div>
    </div>
</template>
<script>
    import store from '../vuex/store.js';
    export default {
        data(){
            return{
                user:'',// 用户信息
                isType:'',// 1.提交下一步 2.详情下一步 3.重新提交

                kind_one:'',// 主要生产产品种类一
                last_year_one:'',// 上年年产量一
                practical_one:'',// 实际年产量一
                total_one:'',// 总体销售额一
                mating_one:'',// 配套额一
                quality_one:'',// 综合质量能力PPM一
                kind_two:'',// 主要生产产品种类二
                last_year_two:'',// 上年年产量二
                practical_two:'',// 实际年产量二
                total_two:'',// 总体销售额二
                mating_two:'',// 配套额二
                quality_two:'',// 综合质量能力PPM二
                variety:false,// 新增产品品类显示隐藏
                approve_one:'',// 何种体系认证/何种资质证书一
                ms_one:'',// 认证时间一
                validity_one:'',// 有效期一
                institution_one:'',// 认证机构一
                number_one:'',// 证书编号一
                approve_two:'',// 何种体系认证/何种资质证书二
                ms_two:'',// 认证时间二
                validity_two:'',// 有效期二
                institution_two:'',// 认证机构二
                number_two:'',// 证书编号二
                isRapex:false,// 新增体系认证情况显示隐藏
                lord:'',// 主代理品牌
                grade_one:'',// 代理等级
                agency_one:'',// 代理证书
                rest:'',// 其他代理品牌
                grade_two:'',// 代理等级
                agency_two:'',// 代理证书
                area_name:'',// 代理区域
                area:[// 代理区域
                    {
                        id:1,
                        name:'全国',
                    },
                    {
                        id:2,
                        name:'区域',
                    },
                    {
                        id:3,
                        name:'其他',
                    }
                ],
                areaId:'',// 代理区域
                quotient_name:'',// 代理区域市场份额
                quotient:[// 代理区域市场份额
                    {
                        id:1,
                        name:'前五',
                    },
                    {
                        id:2,
                        name:'前十',
                    },
                    {
                        id:3,
                        name:'前二十',
                    },
                    {
                        id:4,
                        name:'其他',
                    }
                ],
                quotientId:'',// 代理区域市场份额
                channel:'',// 主要来货渠道
                staple:'',// 曾代理的主要产品
                deal_name:'',// 交期
                deal:[// 交期
                    {
                        id:1,
                        name:'≤3天',
                    },
                    {
                        id:2,
                        name:'≤5天',
                    },
                    {
                        id:3,
                        name:'≤7天',
                    },
                    {
                        id:4,
                        name:'≤15天',
                    },
                    {
                        id:5,
                        name:'≤20天',
                    }
                ],
                dealId:'',// 交期
                logistics:'',// 物流配送
                delivery:[// 物流配送
                    {
                        id:1,
                        name:'自有专车物流配送',
                    },
                    {
                        id:2,
                        name:'第三方物流为主',
                    }
                ],
                deliveryId:'',// 物流配送
                lab_name:'',// 有无实验室
                laboratory:[// 有无实验室
                    {
                        id:1,
                        name:'有',
                    },
                    {
                        id:2,
                        name:'无',
                    }
                ],
                laboratoryId:'',// 有无实验室
                facility:'',// 有无生产设备
                equipment:[// 有无生产设备
                    {
                        id:1,
                        name:'有',
                    },
                    {
                        id:2,
                        name:'无',
                    }
                ],
                facilityId:'',// 有无生产设备
            }
        },
        store,
        methods: {
            //页面跳转
            toViewPage($path,$query) {
                this.$jump.toViewPage(this,$path,$query)
            },
            // 保存草稿
            onSave(){
                const that = this
                let lab ='';// 有无实验室
                if(that.laboratoryId==2){
                    lab = 0
                }else{
                    lab = 1
                }
                let equipment ='';// 有无生产设备
                if(that.facilityId==2){
                    equipment = 0
                }else{
                    equipment = 1
                }
                that.$request({
                    that: that,
                    api: that.$api.editSupply,
                    data: {
                        product_type1:that.kind_one,// 主要生产产品种类一
                        year_capacity1:that.last_year_one,// 上年年产量一
                        reality_capacity1:that.practical_one,// 实际年产量一
                        total_sales1:that.total_one,// 总体销售额一
                        set_amount1:that.mating_one,// 配套额一
                        ppm1:that.quality_one,// 综合质量能力PPM一
                        product_type2:that.kind_two,// 主要生产产品种类二
                        year_capacity2:that.last_year_two,// 上年年产量二
                        reality_capacity2:that.practical_two,// 实际年产量二
                        total_sales2:that.total_two,// 总体销售额二
                        set_amount2:that.mating_two,// 配套额二
                        ppm2:that.quality_two,// 综合质量能力PPM二
                        system1:that.approve_one,// 何种体系认证/何种资质证书一
                        approve_time1:that.ms_one,// 认证时间一
                        end_time1:that.validity_one,// 有效期一
                        approve_body1:that.institution_one,// 认证机构一
                        book_code1:that.number_one,// 证书编号一
                        system2:that.approve_two,// 何种体系认证/何种资质证书二
                        approve_time2:that.ms_two,// 认证时间二
                        end_time2:that.validity_two,// 有效期二
                        approve_body2:that.institution_two,// 认证机构二
                        book_code2:that.number_two,// 证书编号二
                        agent_brand:that.lord,// 主代理品牌
                        agent_level:that.grade_one,// 代理等级
                        agent_book:that.agency_one,// 代理证书
                        other_brand:that.rest,//  其他代理品牌
                        other_level:that.grade_two,// 代理等级
                        other_book:that.agency_two,// 代理证书
                        agent_area:that.areaId,// 代理区域
                        market_share:that.quotientId,// 代理区域市场份额
                        channel:that.channel,// 主要来货渠道
                        once_products:that.staple,// 曾代理的主要产品
                        delivery_cycle:that.dealId,// 交期
                        logistics:that.deliveryId,// 物流配送
                        lab:lab,// 有无实验室
                        equipment:equipment,// 有无生产设备
                        type:2,
                    },
                    success(res) {
                        that.$dialog.toast({
                            mes: res.msg,
                            timeout: 1500,
                            icon: 'success',
                        })
                    }
                })
            },
            // 上一步
            onBack(){
                this.$router.go(-1);
            },
            // 提交下一步
            onSubmit(){
                const that = this
                let lab ='';// 有无实验室
                if(that.laboratoryId==2){
                    lab = 0
                }else{
                    lab = 1
                }
                let equipment ='';// 有无生产设备
                if(that.facilityId==2){
                    equipment = 0
                }else{
                    equipment = 1
                }
                that.$request({
                    that: that,
                    api: that.$api.editSupply,
                    data: {
                        product_type1:that.kind_one,// 主要生产产品种类一
                        year_capacity1:that.last_year_one,// 上年年产量一
                        reality_capacity1:that.practical_one,// 实际年产量一
                        total_sales1:that.total_one,// 总体销售额一
                        set_amount1:that.mating_one,// 配套额一
                        ppm1:that.quality_one,// 综合质量能力PPM一
                        product_type2:that.kind_two,// 主要生产产品种类二
                        year_capacity2:that.last_year_two,// 上年年产量二
                        reality_capacity2:that.practical_two,// 实际年产量二
                        total_sales2:that.total_two,// 总体销售额二
                        set_amount2:that.mating_two,// 配套额二
                        ppm2:that.quality_two,// 综合质量能力PPM二
                        system1:that.approve_one,// 何种体系认证/何种资质证书一
                        approve_time1:that.ms_one,// 认证时间一
                        end_time1:that.validity_one,// 有效期一
                        approve_body1:that.institution_one,// 认证机构一
                        book_code1:that.number_one,// 证书编号一
                        system2:that.approve_two,// 何种体系认证/何种资质证书二
                        approve_time2:that.ms_two,// 认证时间二
                        end_time2:that.validity_two,// 有效期二
                        approve_body2:that.institution_two,// 认证机构二
                        book_code2:that.number_two,// 证书编号二
                        agent_brand:that.lord,// 主代理品牌
                        agent_level:that.grade_one,// 代理等级
                        agent_book:that.agency_one,// 代理证书
                        other_brand:that.rest,//  其他代理品牌
                        other_level:that.grade_two,// 代理等级
                        other_book:that.agency_two,// 代理证书
                        agent_area:that.areaId,// 代理区域
                        market_share:that.quotientId,// 代理区域市场份额
                        channel:that.channel,// 主要来货渠道
                        once_products:that.staple,// 曾代理的主要产品
                        delivery_cycle:that.dealId,// 交期
                        logistics:that.deliveryId,// 物流配送
                        lab:lab,// 有无实验室
                        equipment:equipment,// 有无生产设备
                        type:1,
                    },
                    success(res) {
                        that.$dialog.toast({
                            mes: res.msg,
                            timeout: 1500,
                            icon: 'success',
                            callback(){
                                that.$router.push({ path: '/submit',query:{type:that.isType}})
                            }
                        })
                    }
                })
            },
            // 新增产品品类
            onVariety(){
                this.variety = true
            },
            // 新增体系认证情况
            onRapex(){
                this.isRapex = true
            },
            // 代理区域
            getArea(value){
                this.area_name = value.name
                this.areaId = value.id
            },
            // 代理区域市场份额
            getQuotient(value){
                this.quotient_name = value.name
                this.quotientId = value.id
            },
            // 交期
            getDeal(value){
                this.deal_name = value.name
                this.dealId = value.id
            },
            // 物流配送
            getDelivery(value){
                this.logistics = value.name
                this.deliveryId = value.id
            },
            // 有无实验室
            getLaboratory(value){
                this.lab_name = value.name
                this.laboratoryId = value.id
            },
            // 有无生产设备
            getFacility(value){
                this.facility = value.name
                this.facilityId = value.id
            },
            // 主代理证书上传
            uploadFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_one
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],1)
                }

                console.log('【that.fil】', that.fil)
            },
            // 其他代理证书上传
            restsFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],2)
                }

                console.log('【that.fil】', that.fil)
            },
            // 上传
            uploadData(pdf,i){
                const that = this
                that.imgData = new FormData()
                // that.imgData.append('catalog','bourse')
                // 
                // that.imgData.append('name','images')
                that.imgData.append('type','pdf')
                that.imgData.append('pdf',pdf)
                that.imgData.append('name',that.user.company_name)
                console.log('*********1',that.imgData,i)
                that.$request({
                    that: that,
                    api: that.$api.uploadFile,
                    data: that.imgData,
                    headers: { 'content-type': 'multipart/form-data'},
                    discardSign: true,
                    loading: true,
                    success(res){
                        console.log('打印本次结果：',res,i)
                        // console.log('打印本次上传的图片路径：',res.data)
                        if(i==1){
                            that.agency_one = res.data.src
                        }else{
                            that.agency_two = res.data.src
                        }
                        
                        // console.log('打印查看',that.atlas)
                    },
                    fail(err) {
                        console.log(err)
                        that.$dialog.alert({
                            mes:'上传失败'
                        });
                    }
                })
            },
            // 获取保存草稿
            getDraft(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.firstTrialDraft,
                    data: {},
                    success(res) {
                        that.kind_one = res.data.product_type1 // 主要生产产品种类一
                        that.last_year_one = res.data.year_capacity1 // 上年年产量一
                        that.practical_one = res.data.reality_capacity1 // 实际年产量一
                        that.total_one = res.data.total_sales1 // 总体销售额一
                        that.mating_one = res.data.set_amount1 //  配套额一
                        that.quality_one = res.data.ppm1 // 综合质量能力PPM一
                        that.kind_two = res.data.product_type2 // 主要生产产品种类二
                        that.last_year_two = res.data.year_capacity2 // 上年年产量二
                        that.practical_two = res.data.reality_capacity2 // 实际年产量二
                        that.total_two = res.data.total_sales2 // 总体销售额二 
                        that.mating_two = res.data.set_amount2 // 配套额二
                        that.quality_two = res.data.ppm2 // 综合质量能力PPM二
                        that.approve_one = res.data.system1 // 何种体系认证/何种资质证书一
                        if(res.data.approve_time1!=null&&res.data.approve_time1!=''&&res.data.approve_time1!=''){// 认证时间一
                            that.ms_one = res.data.approve_time1 
                        }
                        if(res.data.end_time1!=null&&res.data.end_time1!=''&&res.data.end_time1!=0){// 有效期一
                            that.validity_one = res.data.end_time1 
                        }
                        that.institution_one = res.data.approve_body1 // 认证机构一
                        that.number_one = res.data.book_code1 // 证书编号一
                        that.approve_two = res.data.system2 // 何种体系认证/何种资质证书二
                        if(res.data.approve_time2!=null&&res.data.approve_time2!=''&&res.data.approve_time2!=0){// 认证时间二
                            that.ms_two = res.data.approve_time2 
                        }
                        if(res.data.end_time2!=null&&res.data.end_time2!=''&&res.data.end_time2!=0){// 有效期二
                            that.validity_two = res.data.end_time2 
                        }
                        that.institution_two = res.data.approve_body2 // 认证机构二
                        that.number_two = res.data.book_code2 // 证书编号二
                        that.lord = res.data.agent_brand // 主代理品牌
                        that.grade_one = res.data.agent_level // 代理等级
                        if(res.data.agent_book!=null&&res.data.agent_book!=''){// 代理证书
                            that.agency_one = res.data.agent_book 
                        }
                        that.rest = res.data.other_brand // 其他代理品牌
                        that.grade_two = res.data.other_level // 代理等级
                        if(res.data.other_book!=null&&res.data.other_book!=''){// 代理证书
                            that.agency_two = res.data.other_book 
                        }
                        
                        if(res.data.agent_area!=null&&res.data.agent_area!=''){// 代理区域
                                that.areaId = res.data.agent_area 
                                if(res.data.agent_area==1){
                                    that.area_name = '全国'
                                }
                                if(res.data.agent_area==2){
                                    that.area_name = '区域'
                                }
                                if(res.data.agent_area==3){
                                    that.area_name = '其他'
                                }
                        }
                        if(res.data.market_share!=null&&res.data.market_share!=''){// 代理区域市场份额
                                that.quotientId = res.data.market_share 
                                if(res.data.market_share==1){
                                    that.quotient_name = '前五'
                                }
                                if(res.data.market_share==2){
                                    that.quotient_name = '前十'
                                }
                                if(res.data.market_share==3){
                                    that.quotient_name = '前二十'
                                }
                                if(res.data.market_share==4){
                                    that.quotient_name = '其他'
                                }
                        }
                        that.channel = res.data.channel // 主要来货渠道
                        that.staple = res.data.once_products // 曾代理的主要产品
                        if(res.data.delivery_cycle!=null&&res.data.delivery_cycle!=''){// 交期
                                that.dealId = res.data.delivery_cycle
                                if(res.data.delivery_cycle==1){
                                    that.deal_name = '≤3天'
                                }
                                if(res.data.delivery_cycle==2){
                                    that.deal_name = '≤5天'
                                }
                                if(res.data.delivery_cycle==3){
                                    that.deal_name = '≤7天'
                                }
                                if(res.data.delivery_cycle==4){
                                    that.deal_name = '≤15天'
                                }
                                if(res.data.delivery_cycle==5){
                                    that.deal_name = '≤20天'
                                }
                        }
                        
                        if(res.data.logistics!=null&&res.data.logistics!=''){// 物流配送
                                that.deliveryId = res.data.logistics
                                if(res.data.logistics==1){
                                    that.logistics = '自有专车物流配送'
                                }else{
                                    that.logistics = '第三方物流为主'
                                }
                        }
                        
                        if(res.data.lab!=null&&res.data.lab!=''){// 有无实验室
                                if(res.data.lab==0){
                                    that.laboratoryId = 2
                                    that.lab_name = '无'
                                }else{
                                    that.laboratoryId = 1
                                    that.lab_name = '有'
                                }
                        }
                        
                        if(res.data.equipment!=null&&res.data.equipment!=''){// 有无生产设备
                                if(res.data.equipment==0){
                                    that.facilityId = 2
                                    that.facility = '无'
                                }else{
                                    that.facilityId = 1
                                    that.facility = '有'
                                }
                        }
                       
                    }
                })
            },
            // 获取审批后详情
            getDetails(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.particulars,
                    data: {},
                    success(res) {
                        that.kind_one = res.data.product_type1 // 主要生产产品种类一
                        that.last_year_one = res.data.year_capacity1 // 上年年产量一
                        that.practical_one = res.data.reality_capacity1 // 实际年产量一
                        that.total_one = res.data.total_sales1 // 总体销售额一
                        that.mating_one = res.data.set_amount1 //  配套额一
                        that.quality_one = res.data.ppm1 // 综合质量能力PPM一
                        that.kind_two = res.data.product_type2 // 主要生产产品种类二
                        that.last_year_two = res.data.year_capacity2 // 上年年产量二
                        that.practical_two = res.data.reality_capacity2 // 实际年产量二
                        that.total_two = res.data.total_sales2 // 总体销售额二 
                        that.mating_two = res.data.set_amount2 // 配套额二
                        that.quality_two = res.data.ppm2 // 综合质量能力PPM二
                        that.approve_one = res.data.system1 // 何种体系认证/何种资质证书一
                        if(res.data.approve_time1!=null&&res.data.approve_time1!=''&&res.data.approve_time1!=''){// 认证时间一
                            that.ms_one = res.data.approve_time1 
                        }
                        if(res.data.end_time1!=null&&res.data.end_time1!=''&&res.data.end_time1!=0){// 有效期一
                            that.validity_one = res.data.end_time1 
                        }
                        that.institution_one = res.data.approve_body1 // 认证机构一
                        that.number_one = res.data.book_code1 // 证书编号一
                        that.approve_two = res.data.system2 // 何种体系认证/何种资质证书二
                        if(res.data.approve_time2!=null&&res.data.approve_time2!=''&&res.data.approve_time2!=0){// 认证时间二
                            that.ms_two = res.data.approve_time2 
                        }
                        if(res.data.end_time2!=null&&res.data.end_time2!=''&&res.data.end_time2!=0){// 有效期二
                            that.validity_two = res.data.end_time2 
                        }
                        that.institution_two = res.data.approve_body2 // 认证机构二
                        that.number_two = res.data.book_code2 // 证书编号二
                        that.lord = res.data.agent_brand // 主代理品牌
                        that.grade_one = res.data.agent_level // 代理等级
                        if(res.data.agent_book!=null&&res.data.agent_book!=''){// 代理证书
                            that.agency_one = res.data.agent_book 
                        }
                        that.rest = res.data.other_brand // 其他代理品牌
                        that.grade_two = res.data.other_level // 代理等级
                        if(res.data.other_book!=null&&res.data.other_book!=''){// 代理证书
                            that.agency_two = res.data.other_book 
                        }
                       
                        if(res.data.agent_area!=null&&res.data.agent_area!=''){// 代理区域
                            that.areaId = res.data.agent_area 
                            if(res.data.agent_area==1){
                                that.area_name = '全国'
                            }
                            if(res.data.agent_area==2){
                                that.area_name = '区域'
                            }
                            if(res.data.agent_area==3){
                                that.area_name = '其他'
                            }
                        }
                        if(res.data.market_share!=null&&res.data.market_share!=''){// 代理区域市场份额
                            that.quotientId = res.data.market_share 
                            if(res.data.market_share==1){
                                that.quotient_name = '前五'
                            }
                            if(res.data.market_share==2){
                                that.quotient_name = '前十'
                            }
                            if(res.data.market_share==3){
                                that.quotient_name = '前二十'
                            }
                            if(res.data.market_share==4){
                                that.quotient_name = '其他'
                            }
                        }
                        that.channel = res.data.channel // 主要来货渠道
                        that.staple = res.data.once_products // 曾代理的主要产品
                        if(res.data.delivery_cycle!=null&&res.data.delivery_cycle!=''){// 交期
                            that.dealId = res.data.delivery_cycle
                            if(res.data.delivery_cycle==1){
                                    that.deal_name = '≤3天'
                            }
                            if(res.data.delivery_cycle==2){
                                    that.deal_name = '≤5天'
                            }
                            if(res.data.delivery_cycle==3){
                                    that.deal_name = '≤7天'
                            }
                            if(res.data.delivery_cycle==4){
                                    that.deal_name = '≤15天'
                            }
                            if(res.data.delivery_cycle==5){
                                    that.deal_name = '≤20天'
                            }
                        }
                        if(res.data.logistics!=null&&res.data.logistics!=''){// 物流配送
                            that.deliveryId = res.data.logistics
                            if(res.data.logistics==1){
                                that.logistics = '自有专车物流配送'
                            }else{
                                that.logistics = '第三方物流为主'
                            }
                        }
                        if(res.data.lab!=null&&res.data.lab!=''){// 有无实验室
                            if(res.data.lab==0){
                                    that.laboratoryId = 2
                                    that.lab_name = '无'
                            }else{
                                    that.laboratoryId = 1
                                    that.lab_name = '有'
                            }
                        }
                        if(res.data.equipment!=null&&res.data.equipment!=''){// 有无生产设备
                            if(res.data.equipment==0){
                                    that.facilityId = 2
                                    that.facility = '无'
                            }else{
                                    that.facilityId = 1
                                    that.facility = '有'
                            }
                        }
                    }
                })
            },
            // 用户信息
            getUser(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.consumer,
                    data: {},
                    success(res) {
                       that.user = res.data
                    }
                })
            },
            // 退出
            onQuit(){
                const that = this
                //存储用户登录凭证
                that.$storage.remove('accesstoken')

                //登录成功发起页面跳转
                that.$dialog.toast({
                    mes: '退出登录成功',
                    timeout: 2000,
                    icon: 'success',
                    callback(){
                        that.$router.push({ path: '/logIn' })
                    }
                })
            },
        },
        mounted() {
            const that = this
            that.$store.commit('EditPageData',this.PageData)
            that.getUser()// 用户信息
            that.isType = that.$route.query.type
            if(that.$route.query.type==2){
                that.getDetails()// 获取审批后详情
            }else{
                that.getDraft()// 获取保存草稿
            }
        },
        components:{
            
        },
    }
</script>


// WEBPACK FOOTER //
// src/page/product.vue